import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import { appOptions } from '../config/app';

import { changeLanguage as changeLanguageAction } from '../actions/languageActions';

class UserMenu extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        label: PropTypes.string.isRequired,
        icon: PropTypes.node,
    };

    static defaultProps = {
        label: 'ra.auth.user_menu',
        icon: <AccountCircle />,
    };

    state = {
        auth: true,
        anchorEl: null,
    };

    changeLanguage(lang) {
        this.props.changeLanguage(lang);
        setTimeout(() => {
            window.location.reload();
        }, 100);
    }

    handleMenu = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    render() {
        const { language, label } = this.props;
        const { anchorEl } = this.state;
        const open = Boolean(anchorEl);

        const user = JSON.parse(localStorage.getItem(appOptions.storageKey));
        const displayLang = localStorage.getItem(appOptions.languageKey) || language;

        let langMenu = null;
        if (user && user.languages) {
        langMenu = user.languages.map(l => (
            <MenuItem key={l.toUpperCase()} onClick={() => this.changeLanguage(l)}>
                {l.toUpperCase()}
            </MenuItem>
        ));
        }

        return (
            <div>
                <Tooltip title={label}>
                    <IconButton
                        aria-label={label}
                        aria-owns={open ? 'menu-appbar' : null}
                        aria-haspopup={true}
                        color="inherit"
                        onClick={this.handleMenu}
                    >
                        {displayLang.toUpperCase()}
                    </IconButton>
                </Tooltip>
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={open}
                    onClose={this.handleClose}
                >
                    {langMenu}
                </Menu>
            </div>
        );
    }
}

const mapStateToProps = state => ({ language: state.language });
export default connect(mapStateToProps, { changeLanguage: changeLanguageAction })(UserMenu);



// WEBPACK FOOTER //
// ./src/resources/languagemenu.js